import { useSnackbar } from 'notistack';
import React from 'react';
import { Link } from 'react-router-dom';
import AppConfig from '../../config';
import { t } from '../../lang';

import './ShortErrorInfo.scss';

const { routes } = AppConfig;

const ShortErrorInfo = ({ error }) => {
	const { closeSnackbar } = useSnackbar();

	const errorMessage = JSON.stringify(
		error?.ErrorMessage ||
			error?.ErrorCode ||
			error?.Error?.Message ||
			error?.Error?.Code ||
			error?.message ||
			error?.Error
	);
	const errorText = error && JSON.stringify(error?.ErrorMessage || error?.Error?.Message || error);
	const errorToPage = errorMessage?.length > 2 && errorText.length < 3 ? errorMessage : errorText;

	return (
		<div className='ShortErrorInfo'>
			{errorMessage?.length > 2 && <div className='ShortErrorInfo__error'>{errorMessage}</div>}
			<Link
				className='ShortErrorInfo__link'
				to={routes.error}
				state={{ error: errorToPage }}
				onClick={() => closeSnackbar()}
			>
				{t('Show more')}
			</Link>
		</div>
	);
};

export default ShortErrorInfo;
